import React from 'react'
import BreadCrumb from '../components/BreadCrumb'
import Header from '../components/header'
import Footer from '../components/footer'
import AboutArea from '../components/AboutArea'
import DownloadArea from '../components/DownloadArea'
import CounterArea from '../components/CounterArea'
import PartnersArea from '../components/PartnersArea'
import GoogleMap from '../components/GoogleMap'


function AboutPage() {
  const pageName = "About Us"
  return (
    <div className='home-3'>
      <Header/>
      <BreadCrumb pageName={pageName}/>
      <main>
        <AboutArea/>
        <CounterArea/>
        <DownloadArea/>
        {/* <PartnersArea/> */}
        <GoogleMap/>
      </main>
      <Footer/>
    </div>
  )
}

export default AboutPage